import React, {Component} from "react";
import DataTable from 'react-data-table-component';
import {Button, Col, Container, Row} from "react-bootstrap";

const conditionalCellStyles = [
    {
        when: row => row.achieveTarget === 'true',
        style: {
            color: "green"
        }
    },
    {
        when: row => row.achieveTarget === 'false',
        style: {
            color: "red"
        }
    }
];

const columns = [
    {
        id: 'impact',
        name: 'Impact',
        selector: 'impact',
        sortable: true
    },
    {
        id: 'useCase',
        name: 'Use case',
        selector: 'useCase',
        sortable: true,
        width: "180px"
    },
    {
        id: 'subUseCase',
        name: 'SubUse case',
        selector: 'subUseCase',
        sortable: true,
        width: "250px"
    },
    {
        id: 'policyIntervention',
        name: 'Policy intervention',
        selector: 'policyIntervention',
        sortable: true,
        width: "300px"
    },
    {
        id: 'achieveTarget',
        name: 'Target from input',
        selector: 'achieveTarget',
        sortable: true,
        conditionalCellStyles: conditionalCellStyles,
        width: "150px"
    },
    {
        id: 'differenceFromInput',
        name: 'Difference from input',
        selector: 'differenceFromInput',
        sortable: false,
        width: "160px"

    },
    {
        id: 'differenceFromInputPercentage',
        name: 'Percentage from input',
        selector: 'differenceFromInputPercentage',
        sortable: false,
        width: "180px"
    },
    {
        id: 'differenceFromBaseline',
        name: 'Difference from SUC baseline',
        selector: 'differenceFromBaseline',
        sortable: false,
        width: "210px"
    },
    {
        id: 'differenceFromBaselinePercentage',
        name: 'Percentage from SUC baseline',
        selector: 'differenceFromBaselinePercentage',
        sortable: true,
        width: "240px"
    }

];

class BackCastingResult extends Component {


    state = {
        targetYear: this.props.targetYear,
        baseScenario: this.props.baseScenario,
        data : this.props.data
    };

    retrieveBaseScenarioDescription(baseScenario) {
        let title = '';

        switch (baseScenario) {
            case 'SCENARIO_1_NO_AUTOMATION':
                title += 'SCENARIO 1 - NO AUTOMATION';
                break;
            case 'SCENARIO_2_PESSIMISTIC':
                title += 'SCENARIO 2 - PESSIMISTIC';
                break;
            case 'SCENARIO_3_NEUTRAL':
                title += 'SCENARIO 3 - NEUTRAL';
                break;
            case 'SCENARIO_4_OPTIMISTIC':
                title += 'SCENARIO 4 - OPTIMISTIC';
                break;
        }

        return title;
    }

    back = () => {
        this.props.history.push('/back_casting');
    }

    retrieveHeaderTitle() {
        return 'BackCasting results for ' + this.retrieveBaseScenarioDescription(this.state.baseScenario) + ' (target year: ' + this.state.targetYear + ')';
    }

    getData(record) {
        return {
            impact: record.impact.impact,
            description: record.impact.description,
            useCase: record.useCase,
            subUseCase: record.subUseCase,
            policyIntervention: record.policyIntervention,
            achieveTarget: record.achieveTarget === null ? '-' : record.achieveTarget ? 'true' : 'false',
            differenceFromInput: record.differenceFromInput !== null ? record.differenceFromInput : '-',
            differenceFromInputPercentage: record.differenceFromInputPercentage !== null ? record.differenceFromInputPercentage : '-',
            differenceFromBaseline: record.differenceFromBaseline !== null ? record.differenceFromBaseline : '-',
            differenceFromBaselinePercentage: record.differenceFromBaselinePercentage !== null ? record.differenceFromBaselinePercentage : '-'
        }
    }

    render() {

        let final_data = this.state.data.map((record) => {
            return this.getData(record);
        });

        return (
            <Container>
                <div className="row py-2">
                    <a href="" onClick={this.back} className="btn btn-outline-primary btn-sm">Back</a>
                </div>
                <div className="row result-header">
                    <h3>{this.retrieveHeaderTitle()}</h3>
                </div>
                <div className="row policy-result">
                    <div className="data-area">
                        <Row>
                            <Col>
                                <DataTable
                                    striped="true"
                                    fixedHeader="true"
                                    fixedHeaderScrollHeight="500px"
                                    columns={columns}
                                    data={final_data}
                                    defaultSortFieldId='impact'
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>

        )
    }
}

export default BackCastingResult;
